// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
export function getDefaultUserAgentKey() {
    return "x-ms-command-name";
}
export function getPlatformSpecificData() {
    var navigator = window.navigator;
    var osInfo = {
        key: "OS",
        value: (navigator.oscpu || navigator.platform).replace(" ", "")
    };
    return [osInfo];
}
